import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { toast } from "react-toastify";
import useIsMobile from "../Hooks/useIsMobile";
import apiService from "../Services/api.service";
import Button from "./Button";
import CustomDatePicker from "./CustomDatePicker";
import PageLoader from "./Loader";
const TransactionDialog = ({ open, onClose, kioskId, history }) => {
  const [transactions, setTransactions] = useState(history || []);
  const [isLoading, setIsLoading] = useState(false);
  const isMobile = useIsMobile();
  const token = localStorage.getItem("token");
  const Currency = {
    USD: "USD",
    INR: "INR",
  };

  const PaymentMethod = {
    CREDIT_CARD: "credit card",
    DEBIT_CARD: "debit card",
    BANK_TRANSFER: "bank transfer",
    CASH: "cash",
    CHEQUE: "cheque",
    UPI: "upi",
    OTHER: "other",
  };

  const [currentTransaction, setCurrentTransaction] = useState({
    amount: "",
    currency: "",
    transactionDate: null,
    method: "",
    transactionId: "",
    notes: "",
  });

  const handleSaveTransaction = async () => {
    try {
      setIsLoading(true);

      const response = await apiService.saveTransaction(
        currentTransaction,
        kioskId,
        token
      );

      if (response.status === 200) {
        onClose();
        window.location.reload();
      } else {
        console.error("Unexpected response status:", response.status);
        toast.error("Transaction failed! Please try again.");
      }
    } catch (error) {
      toast.error("Error adding transaction!");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDateChange = (date) => {
    setCurrentTransaction((prev) => ({
      ...prev,
      transactionDate: date, // Store as dd-mm-yyyy
    }));
  };
  return (
    <Dialog open={open} onClose={onClose}>
      <Box
        sx={{
          height: isMobile ? "auto" : "700px",
          width: isMobile ? "auto" : "600px",
        }}
      >
        <DialogTitle>Add New Transaction</DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{ marginTop: "10px" }}>
            <InputLabel shrink={true} sx={{ backgroundColor: "white", px: 1 }}>
              Payment Method
            </InputLabel>
            <Select
              value={currentTransaction.method}
              onChange={(e) =>
                setCurrentTransaction((prev) => ({
                  ...prev,
                  method: e.target.value,
                }))
              }
            >
              {Object.entries(PaymentMethod).map(([key, value]) => (
                <MenuItem key={key} value={value}>
                  {value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl
            fullWidth
            sx={{ marginTop: "10px", marginBottom: "10px" }}
          >
            <InputLabel shrink={true} sx={{ backgroundColor: "white", px: 1 }}>
              Currency
            </InputLabel>
            <Select
              value={currentTransaction.currency}
              onChange={(e) =>
                setCurrentTransaction((prev) => ({
                  ...prev,
                  currency: e.target.value,
                }))
              }
            >
              {Object.entries(Currency).map(([key, value]) => (
                <MenuItem key={key} value={value}>
                  {value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <CustomDatePicker
            selectedDate={currentTransaction.transactionDate}
            handleDateChange={handleDateChange}
            isDocEditable={true}
            label={"Transaction Date"}
          />

          {[
            { label: "Amount", value: "amount" },

            { label: "Transaction ID", value: "transactionId", type: "text" },
            { label: "Notes", value: "notes", type: "text" },
          ].map((field) => (
            <TextField
              key={field.value}
              label={field.label}
              type={field.type}
              fullWidth
              margin="dense"
              value={currentTransaction[field.value] || ""}
              onChange={(e) =>
                setCurrentTransaction((prev) => ({
                  ...prev,
                  [field.value]: e.target.value,
                }))
              }
            />
          ))}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            backgroundColor="#CCD3DA"
            color="#000"
            hoverColor="#A9A9A9"
            text="Cancel"
            width="150px"
            onClick={onClose}
          />
          <Button text="Save" onClick={handleSaveTransaction} width="150px" />
        </DialogActions>
        {isLoading && <PageLoader />}
      </Box>
    </Dialog>
  );
};

export default TransactionDialog;
